export default __webpack_public_path__ + "static/media/fi-rr-smartphone.a024f584.svg";